import { render, staticRenderFns } from "./MantenedorGrid.vue?vue&type=template&id=a2757884&"
import script from "./MantenedorGrid.vue?vue&type=script&lang=ts&"
export * from "./MantenedorGrid.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports